const es = {
  translation: {
    tooltip: {
      logout: 'Salir',
    },
  },
}

export default es
